import {
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { ClaimData } from "@hooks/useClaims";
import { useState } from "react";
import TableSkeleton from "./TableSkeleton";
import { formatEtherNumber } from "@constants/common";

const ClaimedAirdrops = ({
  airdrops = [],
  isLoading,
}: {
  airdrops: ClaimData[];
  isLoading: boolean;
}) => {
  const [expanded, showExpanded] = useState(false);

  const showViewMore = airdrops.length > 3 && !expanded;

  const visibleAirdrops = expanded ? airdrops : airdrops.slice(0, 3);

  if (!isLoading && airdrops.length === 0) {
    return null;
  }

  return (
    <Flex
      gap={{ base: "0.75rem", md: "1rem" }}
      direction="column"
      flex={1}
      maxW={{ base: "auto", md: "50%" }}
    >
      <Text
        color="textPrimary"
        fontWeight={600}
        fontSize={{ base: "16px", md: "20px" }}
        lineHeight="24px"
      >
        Claimed Airdrops
      </Text>
      <Flex
        padding={{ base: "1rem", md: "2rem 2.5rem" }}
        backgroundColor="white"
        borderRadius={{ base: "1rem", md: "1.5rem" }}
        direction="column"
        gap="1rem"
      >
        {isLoading ? (
          <Flex padding="0.5rem 1.5rem" pr="0rem">
            <TableSkeleton rows={3} columns={2} />
          </Flex>
        ) : (
          <>
            <Table variant="unstyled" color="textPrimary">
              {/* <Show above="md"> */}
              <Thead>
                <Tr>
                  <Th padding="0.75rem 0" pl={1}>
                    Asset
                  </Th>
                  <Th padding="0.75rem 0">Claimed amount</Th>
                </Tr>
              </Thead>
              {/* </Show> */}
              <Tbody>
                {visibleAirdrops.map((airdrop, index) => {
                  const { data, isLoading } = airdrop;
                  if (isLoading) {
                    return null;
                  }

                  return (
                    <Tr key={index} fontSize={{ base: "12px", md: "14px" }}>
                      <Td padding="1rem 0">
                        <Flex gap="0.5rem" alignItems="center" height="100%">
                          <BaseImage
                            src={airdrop.data.iconPath}
                            height={20}
                            width={20}
                            alt={airdrop.key}
                          />
                          {data.asset}
                        </Flex>
                      </Td>
                      <Td padding="1rem 0">{`${formatEtherNumber(
                        data.claimedAmount.toString()
                      )} ${data.unit}`}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
            {showViewMore && (
              <Button
                border="1px solid #B6DFDF"
                bg="#FFFFFF"
                color="#075A5A"
                _hover={{
                  bg: "#FFFFFF",
                }}
                width="fit-content"
                onClick={() => showExpanded(true)}
              >
                View More
              </Button>
            )}
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default ClaimedAirdrops;
